import { brandCaptionLowerThirdPrimary } from "./brand-caption-lower-third-primary";
import { brandCaptionLowerThirdSecondary } from "./brand-caption-lower-third-secondary";

export const brandCaptionLowerThird = {
  type: "object",
  required: ["primary"],
  properties: {
    primary: brandCaptionLowerThirdPrimary,
    secondary: brandCaptionLowerThirdSecondary
  },
  additionalProperties: false
};
